const monitored = {
  cah: [
    {
      slug: "atmosfera",
      title: "En Atmósfera",
      content: () => [
        <h2>Modelo WRF</h2>,
        <p>
          El modelo Weather Research and Forecasting (WRF), actualmente es una
          de las herramientas más usadas para el pronóstico del tiempo y las
          investigaciones atmosféricas a escala regional. Se desarrolló en la
          segunda mitad de la década de 1990, en colaboración entre diferentes
          instituciones de los Estados Unidos de América. En el IGP se ha
          implementado la versión 3.7, inicializada diariamente con datos de las
          00 UTC provenientes del modelo global Global Forecast System (GFS).
          Los esquemas físicos empleados en la configuración del modelo fueron
          seleccionados a partir de los resultados de una investigación
          diagnóstico desarrollada en el período 2017 – 2018 sobre la región de
          interés (Moya et al, 2018; Moya et al, 2020a; Moya et al, 2020b).
        </p>,
        <p>
          El modelo es corrido con 4 dominios: el de Sudamérica y del Pacífico
          oriental (30 km de resolución), un segundo dominio que abarca todo el
          Perú (18 km de resolución). El tercer dominio abarca los Andes
          centrales de Perú (6 km de resolución), y el cuarto dominio, la cuenca
          del Mantaro (2 km de resolución). A partir del cuarto dominio se
          realizó un acercamiento hacia el valle del Mantaro y la cuenca del río
          Rímac.
        </p>,
        <p>
          La información mostrada en esta página es de carácter experimental y
          está orientada principalmente al grupo de investigadores del IGP y
          estudiantes que desarrollan investigaciones en ciencias de la
          atmósfera. Puede ser usada también por usuarios interesados en el
          comportamiento de la atmósfera en América del sur y el Perú a corto
          plazo (48 horas). Ir al{" "}
          <router-link to="/monitoreo-pronostico/">
            {" "}
            “Modelo Weather Research and Forecasting (WRF)”{" "}
          </router-link>
          .
        </p>,
        <br>,</br>,
        <h2>Modelo ARPS</h2>,
        <p>
          El modelo Advance Regional Prediction System (ARPS) es un sistema
          completo de pronóstico y modelado atmosférico regional en escala de
          tormenta e incluye un sistema de asimilación y análisis de datos en
          tiempo real, el sistema de pronóstico directo y un paquete de análisis
          posterior. El modelo ARPS se desarrolló inicialmente en el Centro de
          Análisis y Predicción de Tormentas (CAPS) de la Universidad de
          Oklahoma, con el apoyo del programa de Ciencia y Tecnología de la
          Fundación Científica Nacional.{" "}
        </p>,
        <p>
          El objetivo original del modelo ARPS era que sirviera como un sistema
          prototipo para el pronóstico numérico del tiempo a escala de
          tormentas. La versión 4.0 de ARPS se lanzó oficialmente al público en
          1995. Desde entonces, se han agregado mejoras significativas y se han
          lanzado subversiones posteriores. La versión 5.3.4 de ARPS utiliza el
          formato libre de Fortran 90, asignaciones de matriz dinámica y otras
          características.{" "}
        </p>,
        <p>
          En el IGP, se implementó el ARPS en el año 2017 para realizar estudios
          de eventos de lluvias extremas en los Andes centrales del Perú. En el
          año 2020 se implementó de manera operacional para hacer el monitoreo y
          pronóstico de las tormentas en el valle del Mantaro, utilizando la
          misma configuración descrito en Flores-Rojas et al, (2020) y
          Flores-Rojas et al, (2021). Ir al{" "}
          <router-link to="/monitoreo-pronostico/">
            {" "}
            “Modelo Advance Regional Prediction System (ARPS)”{" "}
          </router-link>
          .
        </p>,
        <br />,
        <h4>Referencias</h4>,
        <p>
          Moya-Álvarez, A. S., Martínez-Castro, D., Flores, J. L., & Silva, Y.
          (2018). Sensitivity study on the influence of parameterization schemes
          in WRF_ARW model on short-and medium-range precipitation forecasts in
          the Central Andes of Peru. Advances in Meteorology, 2018, 1381092.
          https://doi.org/10.1155/2018/1381092
          http://hdl.handle.net/20.500.12816/2297
        </p>,
        <p>
          Moya-Álvarez, A. S., Martínez-Castro, D., Kumar, S., Flores, J. L.,
          Estevan, R., Saavedra-Huanca, M., & Silva, Y. (2020). Statistical
          characterization of vertical meteorological profiles obtained with the
          WRF-ARW model on the central Andes of Peru and its relationship with
          the occurrence of precipitation on the region. Atmospheric Research,
          239, 104915. https://doi.org/10.1016/j.atmosres.2020.104915
          http://hdl.handle.net/20.500.12816/4869
        </p>,
        <p>
          Moya-Álvarez, A. S., Estevan, R., Kumar, S., Flores, J. L., Ticse, J.
          J., Martínez-Castro, D. & Yamina, S. (2020). Influence of PBL
          parameterization schemes in WRF_ARW model on short-range
          precipitation's forecasts in the complex orography of Peruvian Central
          Andes. Atmospheric Research, 104708.
          http://hdl.handle.net/20.500.12816/4714
        </p>,
        <p>
          Flores-Rojas, J. L., Moya-Álvarez, A. S., Valdivia-Prado, J. M.,
          Piñas-Laura, M., Kumar, S., Karam, H. A., Villalobos Puma E.,
          Martínez-Castro, D., Silva, Y. (2021). On the dynamic mechanisms of
          intense rainfall events in the central Andes of Peru, Mantaro valley.
          Atmospheric Research, 248, 105188.
          https://doi.org/10.1016/j.atmosres.2020.105188
          http://hdl.handle.net/20.500.12816/4831
        </p>,
        <p>
          Flores, J. L., Alvarez, A., Kumar, S., Martínez., D., Villalobos, E.,
          & Silva, Y. (2019). Analysis of Possible Triggering Mechanisms of
          Severe Thunderstorms in the Tropical Central Andes of Peru, Mantaro
          Valley. Atmosphere, 10 (6), 301. https://doi.org/10.3390/atmos10060301
          http://hdl.handle.net/20.500.12816/4636
        </p>,
        <br />,
        <h4>Agradecimientos</h4>,
        <p>
          , La implementación del modelo WRF, ARPS y LAMAR en el IGP se realizó
          como parte de varios proyectos, ejecutados por la subdirección de
          Ciencias de la Atmósfera e Hidrósfera de la institución:
        </p>,
        <ol>
          <li>
            Proyecto MAGNET del IGP “Fortalecimiento de la línea de
            investigación en física y microfísica de la atmosférica, cuyo
            objetivo es generar conocimientos, competencias y herramientas sobre
            física y microfísica de la atmósfera, para elevar las capacidades de
            prevención y mitigación de los impactos de eventos meteorológicos
            adversos en los Andes del Perú. Co financiado por FONDECYT del
            CONCYTEC.
          </li>
          <li>
            Proyecto “Modelado hidrogeodinámico (lluvias, huaicos y
            deslizamientos) en Chosica, Lima”, cuyo objetivo es Realizar una
            campaña de observaciones de lluvias usando un radar meteorológico
            para el modelado de lluvias y flujos aluvionales (huaicos) en las
            quebradas de Quirio y Pedregal en Chosica, Lima. Financiado por el
            FONDES.
          </li>
          <li>
            Proyecto “Evaluación de lluvias por radar y modelado de lluvias para
            alerta de huaicos por fuertes lluvias en el valle del Mantaro
            (Junín)”, cuyo objetivo es caracterizar las lluvias intensas en el
            valle del Mantaro utilizando radares y modelos atmosféricos durante
            el periodo de lluvias 2018-2019. Financiado por el FONDES.
          </li>
        </ol>
      ]
    },
    {
      slug: "hidrosfera",
      title: "En Hidrósfera",
      year: 2021,
      content: () => [<p>Próximamente</p>]
    }
  ]
};

function getMonitoring(id) {
  return monitored[id] || monitored["cah"];
}

export { getMonitoring };
